import React from 'react';
import { connect } from "react-redux";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

function ContactUsModal({dispatch, dir, shouldShow, setModalVisible}) {
  const { t } = useTranslation();
  // console.log(`ContactUsModal: ${shouldShow}`)
  // const [show, setShow] = useState(shouldShow);

  const handleClose = () => setModalVisible(false);
  // const handleShow = () => setModalVisible(true);

  return (
    <Modal
      show={shouldShow}
      onHide={handleClose}
      // backdrop="static"
      keyboard={true}
      dir={dir}
      centered
      style={dir === "rtl" ? { textAlign: "right" } : {}}
    >
    <Modal.Header>
        <Modal.Title>{t("contactUsTitle")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {t("contactUsText")}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        {t("noQuestions")}
      </Button>
        <a href={`https://wa.me/972546127601?text=${t("contactUsMessageText")}${encodeURIComponent(window.location)}`} target='_blank'><Button variant="secondary" onClick={handleClose}>{t("contactUsOnWhatsapp")}</Button></a>
    </Modal.Footer>
  </Modal>  )
}

const mapStateToProps = ({ ui }) => ({
  dir: ui.direction,
});

export default connect(mapStateToProps)(ContactUsModal);